<template>
  <div class="container justify-content-center">
    <div class="row">
      <div class="col-md-12">
        <h2 class="mt-5 mb-5">{{ $t(LangConstants.customer_management_title) }}</h2>

        <b-tabs content-class="" class="custom-tab-control" v-model="tabIndex">
          <b-tab title="first" href="#overview">
            <template #title>
              <i class="fa fa-building" aria-hidden="true"></i>
              &nbsp; <span>{{ $t(LangConstants.overview_tab_title) }}</span>
            </template>

            <div v-if="companies && companies.length > 0">
              <div class="row">
                <div class="col-md-6 inline-text">
                  <div class="row mb-4">
                    <b-input-group>
                      <span class="p-2"><i class="icon fa fa-search fa-fw" aria-hidden="true"></i></span>
                      <b-form-input @keyup="searchCompanies" type="text" :placeholder="$t(LangConstants.search_placeholder)" ref="searchInput" v-model="searchText"></b-form-input>
                    </b-input-group>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mb-4" v-for="company in filteredCompanies.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage)" :key="company.companyid">
              <div class="col-md-12">
                <div class="form-base p-3 pt-4">
                  <div class="row p-2">
                    <div class="col-md-10 mb-2">
                      <h3>{{ company.name }}</h3>
                    </div>
                    <div class="col-2 mb-2">
                      <b-row align-h="end">
                        <my-button :label="$t(LangConstants.open_button_label)" variant="solid-primary" height="56px" width="100%" type="button" classes="btn-inline-text" fa="building" fapos="left" @onClick="openCompanyProfile(company.companyid)"></my-button>
                      </b-row>
                    </div>
                  </div>
                  <div class="row mt-2 p-2">
                    <div class="col-sm-4 mb-2">
                      <div class="row">
                        <div class="col-sm-3 p-3">
                          <span class="user-icon"><i class="fa fa-user-circle"></i></span>
                        </div>
                        <div class="col-sm-9 p-2 pl-4">
                          <div class="row">
                            <div class="col-sm-12 inline-text p-1">
                              <b>{{ company.teamLead.firstName + " " + company.teamLead.lastName }}</b>
                            </div>
                            <div class="col-sm-12 inline-text p-1">{{ $t(LangConstants.team_lead_label) }}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-4 mb-2">
                      <div class="row">
                        <div class="col-sm-6 p-2 pl-4">
                          <div class="row">
                            <div class="col-sm-12 inline-text p-1">{{ $t(LangConstants.created_date_label) }}</div>
                            <div class="col-sm-12 inline-text p-1">{{ company.created_date ? dayjs(company.created_date).format("DD-MM-YYYY") : "" }}</div>
                          </div>
                        </div>
                        <div class="col-sm-6 p-2 pl-4">
                          <div class="row">
                            <div class="col-sm-12 inline-text p-1">{{ $t(LangConstants.last_modified_date_label) }}</div>
                            <div class="col-sm-12 inline-text p-1">{{ company.last_changed ? dayjs(company.last_changed).format("DD-MM-YYYY") : "" }}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-2" v-if="filteredCompanies && filteredCompanies.length > 0">
              <div class="mx-auto">
                <pagination :rows="filteredCompanies.length" :perPage="itemsPerPage" class="" ariacontrols="courses-list" @change="handlePageChange" align="center" />
              </div>
            </div>
          </b-tab>
          <b-tab title="Second" href="#newcompany">
            <template #title>
              <i class="fa fa-plus" aria-hidden="true"></i>
              &nbsp;<span>{{ $t(LangConstants.add_customer_tab_title) }}</span>
            </template>
            <div class="row mb-5 mb-md-3">
              <div class="col-auto">
                <h3>{{ this.currentStep == 1 ? $t(LangConstants.company_details_step_label) : $t(LangConstants.company_settings_step_label) }}</h3>
              </div>
              <div class="col-auto">
                <div class="wizard">
                  <ul class="nav nav-tabs" role="tablist">
                    <li role="presentation" v-bind:class="[currentStep == 1 ? 'active' : 'disabled']">
                      <a data-toggle="tab" aria-controls="step1" role="tab" aria-expanded="true">
                        <span class="round-tab" id="step1">1 </span>
                      </a>
                    </li>
                    <li role="presentation" v-bind:class="[currentStep == 2 ? 'active' : 'disabled']">
                      <a data-toggle="tab" aria-controls="step1" role="tab" aria-expanded="true">
                        <span class="round-tab" id="step2">2 </span>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="col-12 mt-3">
                <div class="row">
                  <div class="col-md-12">
                    <div id="step1" v-show="currentStep == 1">
                      <company-details :companyForm="companyForm" :isRegistering="true" @save="addCompanyDetails" />
                    </div>
                    <div id="step2" v-show="currentStep == 2">
                      <company-settings :companyForm="companyForm" :isRegistering="true" :users="users" @save="addSettings" v-if="users" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </b-tab>
        </b-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import Constants from "../../constants/index";
//import MyInput from "../../components/atoms/Input.vue";
import MyButton from "../../components/atoms/Button.vue";
import CompanyDetails from "../../components/organisms/CompanyDetails.vue";
import CompanySettings from "../../components/organisms/CompanySettings.vue";
import Pagination from "../../components/atoms/Pagination.vue";
import Common from "../../functions/index";

import "../../assets/scss/common.scss";

const dayjs = require("dayjs");

export default {
  name: "customer-management",

  async beforeCreate() {},

  async created() {
    await this.$store.dispatch("retrieveUser").then(() => {
      // const query = Object.assign({}, this.$route.query);
      // delete query.force_refresh_user;
      // this.$router.replace({ query });
    });
    const user = Common.getFromLocalStorage(Constants.auth_user, true);
    if (Common.isAuthUser(Constants.teamlead) == true) {
      await this.$store.dispatch("companyGetAllOwn");
      const company = this.$store.getters.allCompanies.find((com) => com.team_lead_userid == user.userid);
      const companyId = company ? company.companyid : null;
      this.$router.push({ name: "CustomerProfile", params: { id: companyId } });
    } else if (Common.isAuthUser(Constants.trainingmanager) == false && Common.isAuthUser(Constants.siteadmin) == false) {
      this.$router.push({ name: "ForbiddenErrorPage" });
    }

    if (this.allCompanies == null || this.allCompanies.length == 0) {
      await this.$store.dispatch("companyGetAllOwn");
    }
    if (this.users == null || this.users.length == 0) {
      // await this.$store.dispatch("getUsers");
      await this.$store.dispatch("getUsersByRoleTeamLead");
    }
    this.setCompanyList();



// console.log(this.$store.getters.allCompanies);


  },

  data() {
    return {
      currentStep: 1,
      companies: [],
      filteredCompanies: [],
      tabIndex: 0,
      tabs: ["#overview", "#newcompany"],
      currentPage: 1,
      itemsPerPage: 5,
      searchText: "",
      companyForm: {
        name: null,
        organization_number: null,
        invoice_email: null,
        address: null,
        phone: null,
        postal_code: null,
        city: null,
        country: null,
        invoice_reference: null,
        team_lead_userid: null,
        allow_invoice: null,
        maximum_license: "*",
        discount: 0,
        instance_id: this.parentCustomerId,
        active: true,
        companyid: 1,
      },
      draftForm: {
        name: null,
        organization_number: null,
        invoice_email: null,
        address: null,
        phone: null,
        postal_code: null,
        city: null,
        country: null,
        invoice_reference: null,
        team_lead_userid: null,
        allow_invoice: null,
        maximum_license: "*",
        discount: 0,
        instance_id: this.parentCustomerId,
        active: true,
      },
      resetForms: false,
    };
  },

  computed: {
    LangConstants() {
      return Constants;
    },

    dayjs() {
      return dayjs;
    },

    users() {
      return this.$store.getters.teamLeads;
    },

    allCompanies() {
      return this.$store.getters.allCompanies;
    },

    parentCustomerId() {
      const authUser = this.$store.getters.getAuthUser;
      return authUser.customer_instance.id;
    },
  },

  mounted() {
    this.tabIndex = this.tabs.findIndex((tab) => tab === this.$route.hash);
  },

  methods: {
    isAuthUser(roleId) {
      return Common.isAuthUser(roleId);
    },

    proceedBtnHandler() {
      this.currentStep++;
    },

    moveToAddCompany() {
      this.companyForm = {
        name: null,
        organization_number: null,
        invoice_email: null,
        address: null,
        phone: null,
        postal_code: null,
        city: null,
        country: null,
        invoice_reference: null,
        team_lead_userid: null,
        allow_invoice: null,
        maximum_license: "*",
        discount: 0,
        instance_id: this.parentCustomerId,
        active: true,
        companyid: 1,
      };
    },

    setCompanyList() {
      let allCompanies = this.allCompanies;
      if (allCompanies && allCompanies.length > 0) {
        this.companies = allCompanies.map((company) => {
          return { id: company.id, companyid: company.companyid, name: company.name, organizationNumber: company.organization_number, teamLead: { firstName: company.team_lead ? company.team_lead.first_name : "", lastName: company.team_lead ? company.team_lead.last_name : "" }, created_date: company.created_at, last_changed: company.updated_at };
        });
      }
      this.filteredCompanies = this.companies;
      this.sortCompanies();
    },

    handlePageChange(page) {
      this.currentPage = page;
    },

    addSettings(form) {
      this.companyForm = form;
      this.createCompany();
    },

    addCompanyDetails(form) {
      this.companyForm = form;
      this.currentStep++;
    },

    async createCompany() {
      try {
        this.companyForm.instance_id = this.parentCustomerId;
        this.companyForm.discount = parseInt(this.companyForm.discount);
        this.companyForm.maximum_license = this.companyForm.maximum_license == "*" ? 999999999 : this.companyForm.maximum_license;

        // let jsondata = "companyname=" + this.companyForm.name;
        // jsondata += "%26organizationnumber=" + this.companyForm.organization_number;
        // jsondata += "%26customercontact=" + this.companyForm.team_lead_userid;
        // jsondata += "%26instance=" + this.companyForm.instance_id;
        // jsondata += "%26invoiceallowed=" + this.companyForm.allow_invoice == true ? 1 : 0;
        // jsondata += "%26phone=" + this.companyForm.phone;
        // jsondata += "%26address=" + this.companyForm.address;
        // jsondata += "%26postalcode=" + this.companyForm.postal_code;
        // jsondata += "%26city=" + this.companyForm.city;
        // jsondata += "%26discount=" + this.companyForm.discount;
        // jsondata += "%26parentcustomerid=" + this.parentCustomerId;
        // jsondata += "%26invoice_reference=" + this.companyForm.invoice_reference;
        // jsondata += "%26invoice_email=" + this.companyForm.invoice_email;
        // jsondata += "%26max_licenses=" + this.companyForm.maximum_license;
        // jsondata += "%26country=" + this.companyForm.country;

        let payload = {
         
            companyname: this.companyForm.name,
            organizationnumber: this.companyForm.organization_number,
            customercontact: this.companyForm.team_lead_userid,
            instance: this.companyForm.instance_id,
            invoiceallowed: this.companyForm.allow_invoice == true ? 1 : 0,
            phone: this.companyForm.phone,
            address: this.companyForm.address,
            postalcode: this.companyForm.postal_code,
            city: this.companyForm.city,
            discount: this.companyForm.discount,
            parentcustomerid: this.parentCustomerId,
            invoice_reference: this.companyForm.invoice_reference,
            invoice_email: this.companyForm.invoice_email,
            max_licenses: this.companyForm.maximum_license,
            country: this.companyForm.country,
            active : true,
         
        };

        payload = JSON.stringify(payload);

        let form = {
          token_retrieval_url: "/login/token.php?username=wsuser&password=wsUs3eR@s!te&service=sparkforeapi",
          // creation_url: '/webservice/rest/server.php?wstoken=<WS_TOKEN_HERE>&wsfunction=local_sparkfore_create_company&moodlewsrestformat=json&jsondata="' + jsondata + '"',
          creation_url: "/webservice/restful/server.php/local_sparkfore_create_company",
          payload: payload,
        };
        const companyCreation = await this.$store.dispatch("companyCreate", form);
        var response = JSON.parse(companyCreation);
        if (response.success == true) {
          await this.$store.dispatch("companyGetAllOwn");
          this.setCompanyList();
          this.currentStep = 1;
          this.companyForm = this.draftForm;
          this.tabIndex = this.tabs.findIndex((tab) => tab === "#overview");
          this.$fire({
            title: response.message,
            type: "success",
            timer: 3000,
          });
        } else {
          this.$fire({
            title: this.$t(this.LangConstants.customer_profile_update_error_message),
            type: "error",
            timer: 3000,
          });
        }
      } catch (error) {
        this.$fire({
          title: error,
          type: "error",
          html: "",
        });
      }
    },

    searchCompanies() {
      let filteredCompanies = [];
      this.filteredCompanies = this.companies.map((company) => {
        if (company.name.toLowerCase().includes(this.searchText.toLowerCase()) > 0 || company.organizationNumber.toLowerCase().includes(this.searchText.toLowerCase()) > 0 || company.teamLead.firstName.toLowerCase().includes(this.searchText.toLowerCase()) > 0 || company.teamLead.lastName.toLowerCase().includes(this.searchText.toLowerCase()) > 0) {
          filteredCompanies.push(company);
        }
      });
      this.filteredCompanies = filteredCompanies;
      this.sortCompanies();
    },

    sortCompanies() {
      this.filteredCompanies.sort(function(a, b) {
        var nameA = a.name.toLowerCase(),
          nameB = b.name.toLowerCase();
        if (nameA < nameB) return -1;
        if (nameA > nameB) return 1;
        return 0;
      });
    },

    openCompanyProfile(companyId) {

      this.$router.replace({ name: "CustomerProfile", params: { id: companyId } });
      //window.parent.location = this.$store.getters.instanceUrl + "v/company-account/customer-profile/" + customerId;
    },
  },

  components: {
    //MyInput,
    MyButton,
    CompanyDetails,
    CompanySettings,
    Pagination,
  },
};
</script>

<style scoped>
.user-icon {
  font-size: 56px;
}
</style>
